
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.returnedFunction = this.$debounce(() => {
        if (this.$matchMedia('lg')) {
          this.$refs.pricingItem.style.maxWidth = this.item.max_width
        } else {
          this.$refs.pricingItem.style.maxWidth = '100%'
        }
      }, 250)

      window.addEventListener('resize', this.returnedFunction)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.returnedFunction)
  },
}
